import { Button } from 'app/components/BasicButtons/Button';
import { translations } from 'locales/translations';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { toQueryString } from 'utils/url-utils';

export interface CloneEquipmentSettingsProps<TRow> {
  rows: TRow[];
  getEquipmentIds: (rows: TRow[]) => number[];
}

export function CloneEquipmentSettings<TRow>({
  rows,
  getEquipmentIds,
}: CloneEquipmentSettingsProps<TRow>) {
  const { t } = useTranslation();

  const link = React.useMemo(() => {
    return `/CloneEquipmentSettings.aspx?${toQueryString({
      target: getEquipmentIds(rows).join(','),
    })}`;
  }, [getEquipmentIds, rows]);
  return (
    <Button variant="white" size="small" href={link} target="_blank">
      {t(translations.menu_CloneEquipmentSettings)}
    </Button>
  );
}
